import { LOCATION_CHANGE } from 'connected-react-router';
import updeep from 'updeep';
import { MODAL_CONTENT_SET, MODAL_CLOSED, MODAL_CONFIG_CHANGED } from '@src/redux/actions/modal';

const DEFAULT_STATE = {
  className: '',
  closeButton: undefined,
  config: {},
  content: undefined,
  doNotCloseOnLocationChange: false,
  hideCloseButton: false,
  onClose: undefined,
  shouldNotCloseOnLocationReplace: false,
  title: undefined,
};

export function modal(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case MODAL_CONFIG_CHANGED: {
      return updeep({ config: action.config }, state);
    }

    case MODAL_CONTENT_SET:
      return {
        ...state,
        className: action.className,
        closeButton: action.closeButton,
        config: action.config,
        content: action.content,
        doNotCloseOnLocationChange: action.doNotCloseOnLocationChange,
        onClose: action.onClose,
        title: action.title,
      };
    case MODAL_CLOSED:
      return DEFAULT_STATE;
    case LOCATION_CHANGE:
      if (state.shouldNotCloseOnLocationReplace && action.payload.action === 'REPLACE') {
        return state;
      }

      if (state.doNotCloseOnLocationChange) {
        return state;
      }

      return DEFAULT_STATE;
    default:
      return state;
  }
}
